<template>
  <div class="container-fluid">
    <div slot="header" class="form-header">
      <h3>{{ $t("WAREHOUSES.EDIT_WAREHOUSE") }}</h3>
    </div>
    <auction-form
      :loading="loading"
      :auctionData="auction"
      :formErrors="formErrors"
      @auctionSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import AuctionForm from "../partials/AuctionForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultAuction from "../defaultAuction";

export default {
  layout: "DashboardLayout",

  components: { AuctionForm },

  mixins: [alertLeave],

  props: {
    auctionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      auction: cloneDeep(defaultAuction),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("auctions/get", this.auctionId);
        this.auction = this.$store.getters["auctions/auction"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(auction) {
      this.loading = true;
      const auctionData = cloneDeep(auction);

      try {
        await this.$store.dispatch("auctions/update", auctionData);
        this.$notify({
          type: "success",
          message: this.$t("AUCTIONS.AUCTION_UPDATED"),
        });
        const auction = await this.$store.getters["auctions/auction"];
        this.$emit("onViewAuction", auction, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
